export default "__VITE_ASSET__c9b8d4de__"